import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    templateUrl: 'failed.component.html',
    styleUrls: ['../message.scss', '../error-message.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FailedComponent {}
